import { Level } from "api/types/alerts";
import GenericDialog from "./generic";
import { useTranslation } from "react-i18next";
import { minutesToTimeString } from "util/datelib";
import LabeledField from "providers/labeledField";
    
const AlertsConfigDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  config: Level[];
}) => {
  const { isOpen, onClose, config } = props;
  const { t } = useTranslation();

  return (
    <GenericDialog
      isOpen={isOpen}
      onExit={onClose}
      onOk={onClose}
      title={t("dialog.alerts.config.title")}
      size="lg"
    >
      <div className="max-h-96 overflow-y-auto">
        <div className="space-y-4">
          {config.length === 0 ? (
            <div className="text-center py-8 text-secondary">
              {t("dialog.alerts.config.noLevels")}
            </div>
          ) : (
            config.map((level, index) => (
              <div
                key={level.index || index}
                className="rounded-lg p-4 bg-background-800 space-y-2"
              >
                <div className="flex items-center justify-between">
                  <div className="text-txt-xl text-primary">
                    {t("dialog.alerts.config.levelTitle", { level: level.index || index + 1 })}
                  </div>
                  <span className="text-sm text-secondary">
                    {t("dialog.alerts.config.levelIndex", { index: level.index || index + 1 })}
                  </span>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <LabeledField label={t("dialog.alerts.config.time")} id={`alerts-config-time-${level.index || index + 1}`}>
                  <div className="text-txt-lg text-primary">
                      {minutesToTimeString(level.time) || '-'}
                    </div>
                  </LabeledField>
                  <LabeledField label={t("dialog.alerts.config.description")} id={`alerts-config-description-${level.index || index + 1}`}>
                  <div className="text-txt-lg text-primary">
                          {level.description || '-'}
                      </div>
                  </LabeledField>
                </div>

                <LabeledField label={t("dialog.alerts.config.recipients")} id={`alerts-config-recipients-${level.index || index + 1}`}>
                {level.recipients && level.recipients.length > 0 ? (
                  <div className="mt-2">
                    <div className="space-y-2">
                      {level.recipients.map((recipient, recipientIndex) => (
                        <div
                          key={recipientIndex}
                          className="bg-white p-3 rounded-lg"
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex-1">
                              <div className="text-txt-md text-primary">
                                {recipient.name || '-'}
                              </div>
                              <div className="text-txt-sm text-secondary">
                                {recipient.email || '-'}
                              </div>
                              {recipient.phone && (
                                <div className="text-txt-sm text-secondary">
                                  {recipient.phone || '-'}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-txt-lg text-secondary">
                    {t("dialog.alerts.config.noRecipients")}
                  </div>
                )}
                </LabeledField>
              </div>
            ))
          )}
        </div>
      </div>
    </GenericDialog>
  );
};

export default AlertsConfigDialog;
